import SuperAgent from 'superagent'
import {api_root} from '@src/index.js'
import {errorHandling, unauthorizedRedirect} from './error.handler.js'
import {getBearerAccessToken} from "./authenticate";


export const systemService = {
  getCommissionedDevices,
  getMetrics,
  getTotalMetrics,
  getNotificationSettings,
  updateNotificationSettings,
  getNotificationState,
  getLocales,
};


function getCommissionedDevices(callback, reject) {
  return SuperAgent
  .get(api_root + "/system/machines")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}



function getMetrics(callback, reject) {
  return SuperAgent
  .get(api_root + "/system/metrics")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}


function getTotalMetrics(callback, reject) {
  return SuperAgent
  .get(api_root + "/system/total_metrics")
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}




function getNotificationSettings(callback, reject) {
  return SuperAgent
  .get(api_root + `/system/notifications/settings`)
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}


function updateNotificationSettings(settings, callback, reject) {
  return SuperAgent
  .post(api_root + `/system/notifications/settings`)
  .send(settings)
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function getNotificationState(callback, reject) {
  return SuperAgent
  .get(api_root + `/system/notifications/mobile_push/state`)
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}

function getLocales(callback, reject) {
  return SuperAgent
  .get(api_root + `/system/locales`)
  .withCredentials()
  .set('Authorization', getBearerAccessToken())
  .use(unauthorizedRedirect)
  .then((response) => {
    const text = response.text;
    const data = text && JSON.parse(text);
    callback(data)
  })
  .catch(reject)
  .catch(errorHandling)
}
